import { useCallback, useState } from "react";
import { request } from "./api/axios";
import API from "./api/url.js";
import { IMAGE_HOST } from "../config/constants";

export const useContest = () => {
  const [contest, setContest] = useState({});
  const getContest = useCallback(async () => {
    const res = await request({
      method: "GET",
      url: API.CONTEST,
    });
    setContest(res?.data?.contest || {});
  }, []);
  return { contest, getContest };
};

export const useActivity = (table) => {
  const [data, setData] = useState([]);
  const getData = useCallback(async () => {
    const res = await request({
      method: "GET",
      url: API.ACTIVITY(table),
    });
    setData(res?.data?.votes || []);
  }, [table]);
  return { data, getData };
};

export const useContestant = () => {
  const [ranks, setRanks] = useState([]);

  const getRanks = useCallback(async (table) => {
    try {
      const res = await request({
        method: "GET",
        url: API.RANK(table),
      });
      setRanks(res?.data?.items || []);
    } catch (e) {
      setRanks([]);
    }
  }, []);

  return {
    ranks,
    getRanks,
  };
};

export const useVoteList = () => {
  const [voteList, setVoteList] = useState([]);
  const [isHasMore, setHasMore] = useState(true);
  const getVoteList = useCallback(
    async (missId, pageNumber, pageSize, table) => {
      if (isHasMore) {
        const res = await request({
          method: "GET",
          url: API.VOTE_LIST(missId, pageNumber, pageSize, table),
        });
        const temp = res?.data?.documents || [];
        if (temp.length === 0) setHasMore(false);
        setVoteList((prev) => prev.concat(temp));
      }
    },
    [isHasMore]
  );
  return { voteList, isHasMore, getVoteList };
};

export const useContestantDetail = (table) => {
  const [contestant, setContestant] = useState({});
  const [time, setTime] = useState({});
  const getContestantDetail = useCallback(async (missId, table) => {
    const res = await request({
      method: "GET",
      url: API.CONTESTANT_DETAIL(missId, table),
    });
    setContestant(res?.data?.contestant || {});
    setTime(res.data?.time || {});
  }, []);

  const getPayUrl = useCallback(async (gateway, missId, combo) => {
    const res = await request({
      method: "POST",
      url: API.PAY_URL(gateway, missId, table),
      data: { comboList: combo },
    });
    return res;
  }, []);

  return { time, contestant, getContestantDetail, getPayUrl };
};

export const configId = (missId) => {
  let configId = missId;
  if (missId === "1") return missId;
  for (let j = 1; j < 2; j++) {
    if (configId && configId.length < 2) {
      configId = "0" + configId;
    }
  }
  return configId;
};

const eventId = "smntn2024ck";

export const getBannerImg = () => {
  return `${IMAGE_HOST}/${eventId}/banner.jpg`;
};

export const getIntroImg = () => {
  return `${IMAGE_HOST}/${eventId}/intro.jpg`;
};

export const getAvatarUrl = (missId, table) => {
  return `${IMAGE_HOST}/${eventId}/Avatar/${missId}.jpg`;
};

export const getDetailImage = (missId, table) => {
  return `${IMAGE_HOST}/${eventId}/Detail/${missId}.jpg`;
};
